/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Builtin_BoardInputs */

const en_views_builtin_board = /** @type {(inputs: Views_Builtin_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Board`)
};

const de_views_builtin_board = /** @type {(inputs: Views_Builtin_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Board`)
};

/**
* | output |
* | --- |
* | "Board" |
*
* @param {Views_Builtin_BoardInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_builtin_board = /** @type {((inputs?: Views_Builtin_BoardInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Builtin_BoardInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_builtin_board(inputs)
	return en_views_builtin_board(inputs)
});